(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[214,8545,8512,9771,2416,9902,2366,5159],{

/***/ 93189:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/excursions/[category_id]",
      function () {
        return __webpack_require__(67712);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Addons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81380);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);



function Addons(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://kit.fontawesome.com/3c7cbada9c.js",
                crossOrigin: "anonymous",
                async: true
            }),
            props.hasOwnProperty("script_sections") ? props.script_sections != null ? props.script_sections.map(function(section, key) {
                return(// section.app_section_content
                section.app_section_content != null ? !section.app_section_content.includes("platform") ? section.app_section_content.split("<script>")[1] != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: section.app_section_content.split("<script>")[1].split("</script>")[0],
                    defer: true
                }, key) : "" : "" : "");
            }) : "" : ""
        ]
    });
}


/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 90261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Articles; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./components/Addons.tsx
var Addons = __webpack_require__(88545);
// EXTERNAL MODULE: ./components/head/BuilderHead.tsx
var BuilderHead = __webpack_require__(56951);
// EXTERNAL MODULE: ./components/templates/index/partials/InlineStyles.tsx
var InlineStyles = __webpack_require__(53408);
// EXTERNAL MODULE: ./components/templates/articles/ArticleCategoriesContainer.tsx
var ArticleCategoriesContainer = __webpack_require__(18630);
;// CONCATENATED MODULE: ./components/templates/articles/Sections.tsx




function Sections(props) {
    var referer = props.referer;
    var app_data = props.app_data;
    var app = props.app;
    var head = props.head;
    var navigation = props.navigation;
    var locations = props.locations;
    var footer = props.footer;
    var contactIcons = props.contactIcons;
    var isDesktop = props.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.content.hasOwnProperty("htmlCode") && Checkers/* default.isValidString */.Z.isValidString(props.content.htmlCode) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: props.content.htmlCode
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                app_data: props.app_data,
                app: props.app,
                builder: props.builder,
                type: props.type,
                content: props.content,
                isDesktop: isDesktop,
                articlesCategories: props.articlesCategories,
                includeJumbotron: true,
                itemClassName: "experience-design-box"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/articles/index.tsx








var Scripts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
function Articles(props) {
    var domain = props.domain;
    var app_data = props.app_data;
    var app = props.app;
    var builder = props.builder;
    var head = props.head;
    var footer = props.footer;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var articlesCategories = props.articlesCategories;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var title = "";
    var titleFbMeta = "";
    var descFbMeta = "";
    var twitter_img_alt = "";
    var imageFbMeta = "";
    var keywords = head.data.meta_keywords;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    var urlHref = props.urlHref;
    title = content.title;
    title += Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? " - " + content.subtitle : "";
    title += " | " + head.data.title;
    titleFbMeta = content.title;
    descFbMeta = Checkers/* default.objChildExists */.Z.objChildExists(content, "description") ? content.description : Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? content.subtitle : "";
    twitter_img_alt = content.title;
    twitter_img_alt += Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? " - " + content.subtitle : "";
    imageFbMeta = Checkers/* default.isValidArray */.Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    if (Checkers/* default.objChildExists */.Z.objChildExists(content, "meta_title") && Checkers/* default.isValidString */.Z.isValidString(content.meta_title)) {
        titleFbMeta = content.meta_title;
        twitter_img_alt = titleFbMeta;
    }
    if (Checkers/* default.objChildExists */.Z.objChildExists(content, "meta_desc") && Checkers/* default.isValidString */.Z.isValidString(content.meta_desc)) {
        descFbMeta = content.meta_desc;
    }
    if (Checkers/* default.objChildExists */.Z.objChildExists(content, "meta_keywords") && Checkers/* default.isValidString */.Z.isValidString(content.meta_keywords)) {
        keywords = content.meta_keywords;
    }
    if (props.isArticle) {
        descFbMeta = content.description.replace(/(<([^>]+)>)/gi, "");
        imageFbMeta = Checkers/* default.isValidArray */.Z.isValidArray(content.images) && Checkers/* default.isValidString */.Z.isValidString(content.images[0].image) ? content.images[0].image : null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineStyles/* InlineStyles */.f, {
                app: app,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderHead/* default */.Z, {
                title: title,
                keywords: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaKeywords) ? props.app.blogMetaKeywords : keywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaTitle) ? props.app.blogMetaTitle : titleFbMeta,
                desc_fb_meta: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaDescription) ? props.app.blogMetaDescription : keywords,
                image_fb_meta: imageFbMeta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: twitter_img_alt,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location.address,
                googleSchemaCity: head.location.city,
                googleSchemaCountry: head.location.country,
                googleSchemaZip: head.location.zip,
                googleSchemaPhone: head.location.phone,
                designColor: app.designColor,
                font: app.font,
                manager: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections, {
                type: props.type,
                isBlogArticle: props.isBlogArticle,
                isDesktop: isDesktop,
                app_data: app_data,
                app: app,
                head: head,
                navigation: navigation,
                locations: locations,
                contactIcons: contactIcons,
                content: content,
                articlesCategories: articlesCategories,
                footer: footer,
                builder: builder,
                htmlSections: props.htmlSections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Addons["default"], {})
        ]
    });
}


/***/ }),

/***/ 67712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1860);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46797);
/* harmony import */ var _components_templates_articles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90261);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28207);
// import TagManager from "react-gtm-module";










var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
function Home(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app_data = props.app_data;
    var app = props.app;
    var head = props.head;
    var footer = props.footer;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var builder = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].objChildExists */ .Z.objChildExists(app, "builder") ? app.builder : null;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (window !== undefined) {
            window.designMode = app.designMode;
        }
        _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_5__/* .Fancybox.bind */ .KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_articles__WEBPACK_IMPORTED_MODULE_6__["default"], {
                type: "experiences",
                isArticle: false,
                isArticleCategory: true,
                isBlogArticle: false,
                domain: domain,
                app_data: app_data,
                app: app,
                head: head,
                footer: footer,
                locations: locations,
                navigation: navigation,
                content: content,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor,
                isDesktop: isDesktop,
                image_fb_meta: image_fb_meta,
                contactIcons: contactIcons,
                urlHref: urlHref,
                builder: builder,
                htmlSections: props.html_sections
            })
        })
    }));
}


/***/ }),

/***/ 81380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88512)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8201,8340,9007,5553,3098,77,5634,9656,8024,2817,9445,5175,4795,2368,6442,8207,1345,6171,5885,9350,8630,9774,2888,179], function() { return __webpack_exec__(93189); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);